import { Client } from '../../models';
import {
  CreateClientRequest,
  CreateEntityTypeRequest,
} from '../../../../web-api-client';

export const mapClientToCreateRequest = (
  client: Client
): CreateClientRequest => {
  return new CreateEntityTypeRequest({
    name: client.name,
    description: client.description,
    isActive: client.isActive,
  });
};
